import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 开票税率分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemParamInvoiceTaxRate extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Name = 0;
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 发票种类
     */
    Type?: string;
    /**
     * 税率
     */
    Name?: number;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 开票税率分页列表-项-表单校验
 */
export const DtoListItemParamInvoiceTaxRateRules = {
}

/**
 * 开票税率分页列表-项-设置项
 */
export const DtoListItemParamInvoiceTaxRateMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Type",
    Label: "发票种类",
  },
  {
    Prop: "Name",
    Label: "税率",
    Customize: true,
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
]
